var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-table',{attrs:{"columns":_vm.columns,"data-source":_vm.list,"scroll":{ x: 0, y: _vm.y },"pagination":false,"loading":_vm.listLoading,"destroyOnClose":true,"forceRender":true,"rowClassName":_vm.rowClassName},scopedSlots:_vm._u([{key:"content",fn:function(text,record){return [_vm._v(" "+_vm._s(_vm._f("numberFixed")(text,record.unit ==='MJ' || record.unit === 'Kcal'? 0 : 2))+" ")]}},{key:"productContent",fn:function(text,record){return [_vm._v(" "+_vm._s(_vm._f("numberFixed")(text,record.unit ==='MJ' || record.unit === 'Kcal'? 0 : 2))+" ")]}},{key:"difference",fn:function(text, record){return [_c('span',{class:{
        red:
          record.content && record.content !== 0 ? 
          Number((record.content || 0) - (record.productContent || 0)) > 0 
          : false,
        green:
          record.content && record.content !== 0 ? 
          Number((record.content || 0) - (record.productContent || 0)) < 0
          : false
      }},[_vm._v(" "+_vm._s(_vm.getNum(record))+" ")])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }